import { useVacancyControllerGetVacancyQuery } from '@api/admin/adminGeneratedApi';

export const useGetVacancyById = (id: string) => {
  const { data, refetch, isLoading } = useVacancyControllerGetVacancyQuery({
    id,
  });

  return {
    data,
    refetch,
    isLoading,
  };
};
